import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  stocks: [],
  watchList: {
    id: null,
    stocks: [],
    stockSymbols: [],
    colorCodes: []
  },
  isLoading: true
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
